/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ShadowAdmissionNextSteps } from './ShadowAdmissionNextSteps';
import {
    ShadowAdmissionNextStepsFromJSON,
    ShadowAdmissionNextStepsFromJSONTyped,
    ShadowAdmissionNextStepsToJSON,
} from './ShadowAdmissionNextSteps';
import type { ShadowAdmissionReasoning } from './ShadowAdmissionReasoning';
import {
    ShadowAdmissionReasoningFromJSON,
    ShadowAdmissionReasoningFromJSONTyped,
    ShadowAdmissionReasoningToJSON,
} from './ShadowAdmissionReasoning';
import type { ShadowComponentCriterionDetail } from './ShadowComponentCriterionDetail';
import {
    ShadowComponentCriterionDetailFromJSON,
    ShadowComponentCriterionDetailFromJSONTyped,
    ShadowComponentCriterionDetailToJSON,
} from './ShadowComponentCriterionDetail';
import type { ShadowDealbreakerFlag } from './ShadowDealbreakerFlag';
import {
    ShadowDealbreakerFlagFromJSON,
    ShadowDealbreakerFlagFromJSONTyped,
    ShadowDealbreakerFlagToJSON,
} from './ShadowDealbreakerFlag';
import type { ShadowDecisionOutcome } from './ShadowDecisionOutcome';
import {
    ShadowDecisionOutcomeFromJSON,
    ShadowDecisionOutcomeFromJSONTyped,
    ShadowDecisionOutcomeToJSON,
} from './ShadowDecisionOutcome';
import type { ShadowSubsystemResults } from './ShadowSubsystemResults';
import {
    ShadowSubsystemResultsFromJSON,
    ShadowSubsystemResultsFromJSONTyped,
    ShadowSubsystemResultsToJSON,
} from './ShadowSubsystemResults';
import type { ShadowThresholdMode } from './ShadowThresholdMode';
import {
    ShadowThresholdModeFromJSON,
    ShadowThresholdModeFromJSONTyped,
    ShadowThresholdModeToJSON,
} from './ShadowThresholdMode';

/**
 * Pass-through of the latest shadow_admission_decisions row for a lead.
 * Returns has_shadow_decision=false (and no other fields) when no row exists.
 * 
 * @export
 * @interface ShadowDecision
 */
export interface ShadowDecision {
    /**
     * 
     * @type {boolean}
     * @memberof ShadowDecision
     */
    has_shadow_decision: boolean;
    /**
     * 
     * @type {ShadowDecisionOutcome}
     * @memberof ShadowDecision
     */
    shadow_decision?: ShadowDecisionOutcome;
    /**
     * 
     * @type {number}
     * @memberof ShadowDecision
     */
    aggregate_score?: number;
    /**
     * 
     * @type {number}
     * @memberof ShadowDecision
     */
    threshold_used?: number;
    /**
     * 
     * @type {ShadowThresholdMode}
     * @memberof ShadowDecision
     */
    threshold_mode?: ShadowThresholdMode;
    /**
     * 
     * @type {ShadowAdmissionReasoning}
     * @memberof ShadowDecision
     */
    reasoning?: ShadowAdmissionReasoning;
    /**
     * 
     * @type {ShadowAdmissionNextSteps}
     * @memberof ShadowDecision
     */
    next_steps?: ShadowAdmissionNextSteps;
    /**
     * 
     * @type {ShadowSubsystemResults}
     * @memberof ShadowDecision
     */
    subsystem_results?: ShadowSubsystemResults;
    /**
     * 
     * @type {Array<ShadowDealbreakerFlag>}
     * @memberof ShadowDecision
     */
    dealbreaker_flags?: Array<ShadowDealbreakerFlag>;
    /**
     * 
     * @type {Array<ShadowComponentCriterionDetail>}
     * @memberof ShadowDecision
     */
    component_detail?: Array<ShadowComponentCriterionDetail>;
    /**
     * 
     * @type {string}
     * @memberof ShadowDecision
     */
    model_name?: string;
    /**
     * 
     * @type {number}
     * @memberof ShadowDecision
     */
    analysis_results_count?: number;
    /**
     * 
     * @type {string}
     * @memberof ShadowDecision
     */
    date_created?: string;
}

/**
 * Check if a given object implements the ShadowDecision interface.
 */
export function instanceOfShadowDecision(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "has_shadow_decision" in value;

    return isInstance;
}

export function ShadowDecisionFromJSON(json: any): ShadowDecision {
    return ShadowDecisionFromJSONTyped(json, false);
}

export function ShadowDecisionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShadowDecision {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'has_shadow_decision': json['has_shadow_decision'],
        'shadow_decision': !exists(json, 'shadow_decision') ? undefined : ShadowDecisionOutcomeFromJSON(json['shadow_decision']),
        'aggregate_score': !exists(json, 'aggregate_score') ? undefined : json['aggregate_score'],
        'threshold_used': !exists(json, 'threshold_used') ? undefined : json['threshold_used'],
        'threshold_mode': !exists(json, 'threshold_mode') ? undefined : ShadowThresholdModeFromJSON(json['threshold_mode']),
        'reasoning': !exists(json, 'reasoning') ? undefined : ShadowAdmissionReasoningFromJSON(json['reasoning']),
        'next_steps': !exists(json, 'next_steps') ? undefined : ShadowAdmissionNextStepsFromJSON(json['next_steps']),
        'subsystem_results': !exists(json, 'subsystem_results') ? undefined : ShadowSubsystemResultsFromJSON(json['subsystem_results']),
        'dealbreaker_flags': !exists(json, 'dealbreaker_flags') ? undefined : ((json['dealbreaker_flags'] as Array<any>).map(ShadowDealbreakerFlagFromJSON)),
        'component_detail': !exists(json, 'component_detail') ? undefined : ((json['component_detail'] as Array<any>).map(ShadowComponentCriterionDetailFromJSON)),
        'model_name': !exists(json, 'model_name') ? undefined : json['model_name'],
        'analysis_results_count': !exists(json, 'analysis_results_count') ? undefined : json['analysis_results_count'],
        'date_created': !exists(json, 'date_created') ? undefined : json['date_created'],
    };
}

export function ShadowDecisionToJSON(value?: ShadowDecision | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'has_shadow_decision': value.has_shadow_decision,
        'shadow_decision': ShadowDecisionOutcomeToJSON(value.shadow_decision),
        'aggregate_score': value.aggregate_score,
        'threshold_used': value.threshold_used,
        'threshold_mode': ShadowThresholdModeToJSON(value.threshold_mode),
        'reasoning': ShadowAdmissionReasoningToJSON(value.reasoning),
        'next_steps': ShadowAdmissionNextStepsToJSON(value.next_steps),
        'subsystem_results': ShadowSubsystemResultsToJSON(value.subsystem_results),
        'dealbreaker_flags': value.dealbreaker_flags === undefined ? undefined : ((value.dealbreaker_flags as Array<any>).map(ShadowDealbreakerFlagToJSON)),
        'component_detail': value.component_detail === undefined ? undefined : ((value.component_detail as Array<any>).map(ShadowComponentCriterionDetailToJSON)),
        'model_name': value.model_name,
        'analysis_results_count': value.analysis_results_count,
        'date_created': value.date_created,
    };
}

